/* unplugin-vue-components disabled */import script from "./Switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./Switch.vue?vue&type=script&setup=true&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=7fb5203b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb5203b"]])

export default __exports__